import { useTranslation } from 'react-i18next'

import AiMarketingLayout from '../_shared/AiMarketingLayout'
import Overview from './Overview'

export const KolRecommendRoute = () => {
  const { t } = useTranslation(['aiMarketingAssistant', 'common'])

  return (
    <AiMarketingLayout
      title={t('aiMarketingAssistant:kol_recommendation.empty_title')}
      breadcrumbText={t('common:route.kol_recommend')}
    >
      {productId =>
        Boolean(productId) && <Overview key={productId} productId={productId} />
      }
    </AiMarketingLayout>
  )
}
